import React from 'react';
import { 
  readOnlyFill, 
  fillMaxMin, 
  vsSNPFill, 
  format, 
  formatPercent 
} from '../Helpers';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const TableHeader = ({ 
  title, 
  sectorSymbol, 
  sectorInfo, 
  theme, 
  hide, 
  openModal,
}) => {

  const item = sectorInfo.filter(sector => sector.symbol === sectorSymbol)[0];
  if (!item) return null;

  const tooltipSectorPrice = (
    <Tooltip id="tooltipIncrease">
      Price: {item.price}
    </Tooltip>
  );

  return (
    <tr className={'header-row ' + theme}>

      <td></td> 
      <td></td> 
      <td></td> 
      <td></td> 
      <td></td> 
      <td></td> 

      <td className="sector-row-heading" onClick={() => openModal(item)}>
        {title}
      </td>

      <td></td> 
      <td></td> 
      <td></td> 
      {/*<td></td> */}
      {/*<td></td> */}

      <td className={readOnlyFill(item.resistance, item.price)}>
        {item.resistance}
      </td>

      <OverlayTrigger placement="top" overlay={tooltipSectorPrice}>
        <td className="sector-symbol">
          {item.symbol}
        </td>
      </OverlayTrigger>

      <td className={readOnlyFill(item.price, item.support)}>
        {item.support}
      </td>

      <td>
        {formatPercent(item.scmSectorWeight)}
      </td>

      <td className={vsSNPFill(item.vsSNP)}>
        {formatPercent(item.vsSNP)}
      </td>

      <td>
        {formatPercent(item.sectorWeight)}
      </td>

      <td className={fillMaxMin(item.scmSector, 'scmSector', sectorInfo)}>
         {formatPercent(item.scmSector)}
      </td>

      <td className={fillMaxMin(item.etfTodayPercent, 'etfTodayPercent', sectorInfo)}>
        {formatPercent(item.etfTodayPercent)}
      </td>

      <td style={hide()}>
        {item.quarterly}
      </td>

      <td className={fillMaxMin(item.lagLead, 'lagLead', sectorInfo)}>
        {format(item.lagLead)}
      </td>

      <td></td>
      <td style={hide()}></td>
      <td style={hide()}></td>

      <td style={hide()}>
        {format(item.quarterlyCostBasis)}
      </td>

      <td style={hide()}>
        {item.adjCostbasisTotal}
      </td>

      <td className={fillMaxMin(item.sgPerf, 'sgPerf', sectorInfo)}>
        {formatPercent(item.sgPerf)}
      </td>

      <td className={fillMaxMin(item.etfPerf, 'etfPerf', sectorInfo)}>
        {formatPercent(item.etfPerf)}
      </td>

      <td style={hide()}>
        {item.quarter1}
      </td>

      <td style={hide()}>
        {item.quarter2}
      </td>

      <td style={hide()}>
        {item.quarter3}
      </td>

      <td className={fillMaxMin(item.quarterLagLead, 'quarterLagLead', sectorInfo)}>
        {format(item.quarterLagLead)}
      </td>

      <td style={{ textAlign: 'center' }}>
        {item.why}
      </td>

      <td className={fillMaxMin(item.ytdTotal, 'ytdTotal', sectorInfo)}>
        {format(item.ytdTotal)}
      </td>

      <td style={hide()}></td>
      <td style={hide()}></td>

      <td>
        {item.deck}
      </td>

      <td style={hide()}>
        {item.notes}
      </td>

    </tr>
  );
}

export default TableHeader;

